import script from "./MerchantsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MerchantsPage.vue?vue&type=script&setup=true&lang=ts"

import "./MerchantsPage.vue?vue&type=style&index=0&id=a794b25a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a794b25a"]])

export default __exports__